module.exports = __webpack_public_path__ + "static/media/microdurometro.76709eec.jpg";